import React from 'react';
import { Pencil, Trash2 } from 'lucide-react';
import type { EmailTemplate } from '../types';

interface TemplateCardProps {
  template: EmailTemplate;
  onEdit: (template: EmailTemplate) => void;
  onDelete: (templateId: string) => void;
  isDeleting?: boolean;
}

export const TemplateCard: React.FC<TemplateCardProps> = ({
  template,
  onEdit,
  onDelete,
  isDeleting = false,
}) => {
  return (
    <div className="bg-white border border-slate-200/80 rounded-[16px] p-6 flex flex-col justify-between hover:-translate-y-1.5 hover:shadow-[0_12px_24px_rgba(15,23,42,0.06)] transition-all duration-300 ease-out group font-hanken">
      <div>
        {/* Template Name */}
        <h3 className="font-semibold text-slate-900 text-[16px] leading-snug mb-1 tracking-tight">
          {template.name}
        </h3>
        {/* Subject */}
        <span className="text-slate-500 italic text-sm mb-4 leading-normal font-medium block">
          {template.subject}
        </span>
        {/* Body snippet */}
        <p className="text-slate-600 text-[14px] leading-relaxed mb-6 font-normal line-clamp-3">
          {template.body}
        </p>
      </div>

      {/* Bottom Actions and Date Badge */}
      <div className="flex items-center justify-between pt-2">
        <span className="px-3 py-1.5 bg-[#F8FAFC] text-slate-500 text-xs font-semibold rounded-[8px] border border-slate-100/80">
          {new Date(template.created_at).toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
          })}
        </span>
        <div className="flex items-center gap-2">
          <button
            onClick={() => onEdit(template)}
            className="h-8 w-8 flex items-center justify-center border border-slate-200 rounded-[8px] text-slate-400 hover:text-slate-700 hover:bg-slate-50 transition-colors"
            title="Edit Template"
          >
            <Pencil className="w-4 h-4 stroke-[1.8]" />
          </button>
          <button
            onClick={() => onDelete(template.id)}
            className="h-8 w-8 flex items-center justify-center border border-slate-200 rounded-[8px] text-slate-400 hover:text-red-500 hover:bg-red-50 hover:border-red-100 transition-colors disabled:opacity-50"
            title="Delete Template"
            disabled={isDeleting}
          >
            <Trash2 className="w-4 h-4 stroke-[1.8]" />
          </button>
        </div>
      </div>
    </div>
  );
};
